<template>
  <div class="boiler-tab">
    <div class="tab-title add-flex j-sb">
      <div class="tabs">
        <input
          type="radio"
          value="1"
          id="tab1"
          v-model="isActive"
          :disabled="!boilerRoom.isMintable"
        />
        <label for="tab1">Mint</label>

        <input
          type="radio"
          value="2"
          id="tab2"
          v-model="isActive"
          :disabled="!boilerRoom.isRedeemable"
        />
        <label for="tab2">Redeem</label>
      </div>
      <div class="add-token">
        <button @click.prevent="addToMetamask" class="item d-icon">
          <img src="/assets/sf/icon/wallet-metamask.svg" />
          Add Token
        </button>
      </div>
    </div>

    <ul class="tab-contents">
      <li v-show="isActive == '1'">
        <p class="title">MINT</p>
        <div class="v-wrap add-flex j-sb">
          <div class="price-icon add-flex">
            <figure>
              <img src="/assets/sf/icon/busd-s.svg" />
            </figure>
            <h4 v-if="boilerRoom.account.busdBalance == 0">
              <b>BUSD</b>
              <br />
              Bal. -
            </h4>
            <h4 v-else>
              <b>BUSD</b>
              <br />
              Bal.
              {{ toFormattedToken(boilerRoom.account.busdBalance) }}
            </h4>
          </div>
          <div
            class="price-value desc"
            @click="handlePriceValueClick('mintBusdValueRef')"
          >
            <p class="price-value__available">
              {{ toFormattedToken(boilerRoom.account.busdBalance) }} BUSD Tokens
              Avaliable
            </p>
            <div class="price-value__inputs">
              <button
                class="btn-max"
                @click.prevent="handleMaxClick"
                :disabled="
                  !$store.state.isLogin || !boilerRoom.account.isApproved
                "
              >
                Max
              </button>
              <!-- <span
              v-if="isMintBoilerEditing"
              @click.prevent="isMintBoilerEditing = false"
              class="price-num"
              :class="{
                'price-num__disabled':
                  !$store.state.isLogin || !boilerRoom.account.isApproved,
              }"
              >{{ mintBoilerValue }}</span
            > -->
              <input
                @keydown="handleKeydown"
                ref="mintBusdValueRef"
                type="number"
                v-model="mintBusdValue"
                min="0"
                step=".000000000000000001"
                :disabled="
                  !$store.state.isLogin || !boilerRoom.account.isApproved
                "
              />
            </div>
          </div>
        </div>

        <div class="arrow"></div>

        <p class="sub-title">Output</p>
        <div class="v-wrap add-flex j-sb">
          <div class="price-icon add-flex">
            <figure>
              <img src="/assets/sf/icon/boiler.svg" />
            </figure>
            <h4 v-if="boilerRoom.account.balance == 0">
              <b>BOILER</b>
              <br />
              Bal. -
            </h4>
            <h4 v-else>
              <b>BOILER</b>
              <br />
              Bal. {{ toFormattedToken(boilerRoom.account.balance) }}
            </h4>
          </div>
          <div
            class="price-value"
            @click="handlePriceValueClick('mintBoilerValueRef')"
          >
            <!-- <span
              v-if="!isMintBoilerEditing"
              @click.prevent="isMintBoilerEditing = true"
              class="price-num"
              :class="{
                'price-num__disabled':
                  !$store.state.isLogin || !boilerRoom.account.isApproved,
              }"
              >{{ mintBoilerValue }}</span
            > -->
            <input
              @keydown="handleKeydown"
              ref="mintBoilerValueRef"
              type="number"
              v-model="mintBoilerValue"
              min="0"
              step=".000000000000000001"
              :disabled="
                !$store.state.isLogin || !boilerRoom.account.isApproved
              "
            />
          </div>
        </div>

        <div class="fee add-flex j-sb" v-if="mintingFee > 0">
          <p class="sub-title">Minting Fee</p>
          <p class="sub-title">{{ mintingFee }}%</p>
        </div>
        <div
          class="fee add-flex j-sb"
          v-if="boilerRoom.account.claimableMintsBalance > 0"
        >
          <p class="sub-title">Claimable Mints</p>
          <p class="sub-title">
            {{ toFormattedToken(boilerRoom.account.claimableMintsBalance) }}
          </p>
        </div>
        <div class="connect">
          <input-button
            v-if="!$store.state.isLogin"
            :size="'big'"
            @click="openModal('modal-connect-wallet')"
            >connect to wallet</input-button
          >
          <input-button
            v-if="$store.state.isLogin && !boilerRoom.account.isApproved"
            :size="'large'"
            :is-loading="isLoading"
            :disabled="isLoading"
            @click="approve()"
            >{{ isLoading ? "Approving" : "Approve" }}</input-button
          >
          <input-button
            v-if="
              $store.state.isLogin &&
              boilerRoom.account.isApproved &&
              boilerRoom.account.claimableMintsBalance == 0
            "
            :size="'large'"
            :is-loading="isLoading"
            :disabled="isDisabledMinting"
            @click="mint()"
            >{{ isLoading ? "Minting" : "Mint" }}</input-button
          >
          <input-button
            v-if="
              $store.state.isLogin &&
              boilerRoom.account.isApproved &&
              boilerRoom.account.claimableMintsBalance > 0
            "
            :size="'large'"
            :is-loading="isLoading"
            :disabled="boilerRoom.account.claimableMintsBalance == 0"
            @click="mint()"
            >{{ isLoading ? "Claiming" : "Claim" }}</input-button
          >
        </div>
      </li>

      <li v-show="isActive == '2'">
        <p class="title">REDEEM</p>
        <div class="v-wrap add-flex j-sb">
          <div class="price-icon add-flex">
            <figure>
              <img src="/assets/sf/icon/boiler.svg" />
            </figure>
            <h4 v-if="boilerRoom.account.balance == 0">
              <b>Boiler</b>
              <br />
              Bal. -
            </h4>
            <h4 v-else>
              <b>Boiler</b>
              <br />
              Bal. {{ toFormattedToken(boilerRoom.account.balance) }}
            </h4>
          </div>
          <div
            class="price-value desc"
            @click.prevent="handlePriceValueClick('redeemBoilerValueRef')"
          >
            <p class="price-value__available">
              {{ toFormattedToken(boilerRoom.account.balance) }} BOILER Tokens
              Avaliable
            </p>
            <div class="price-value__inputs">
              <button
                class="btn-max"
                @click.prevent="handleMaxClick"
                :disabled="
                  !$store.state.isLogin || !boilerRoom.account.isApproved
                "
              >
                Max
              </button>
              <input
                @keydown="handleKeydown"
                ref="redeemBoilerValueRef"
                type="number"
                v-model="boilerValue"
                min="0"
                step=".000000000000000001"
                :disabled="
                  !$store.state.isLogin || !boilerRoom.account.isApproved
                "
              />
            </div>
          </div>
        </div>

        <div class="arrow"></div>

        <p class="sub-title">Output</p>
        <div class="v-wrap add-flex j-sb">
          <div class="price-icon add-flex">
            <figure>
              <img src="/assets/sf/icon/busd-s.svg" />
            </figure>
            <h4 v-if="boilerRoom.account.busdBalance == 0">
              <b>BUSD</b>
              <br />
              Bal. -
            </h4>
            <h4 v-else>
              <b>BUSD</b>
              <br />
              Bal. {{ toFormattedToken(boilerRoom.account.busdBalance) }}
            </h4>
          </div>
          <div class="price-value">
            <span
              class="price-num"
              :class="{
                'price-num__disabled':
                  !$store.state.isLogin || !boilerRoom.account.isApproved,
              }"
              >{{ redeemBusdAmount }}</span
            >
          </div>
        </div>

        <div class="v-wrap add-flex j-sb">
          <div class="price-icon add-flex">
            <figure>
              <img src="/assets/sf/image/icon_grad.png" />
            </figure>
            <h4 v-if="boilerRoom.account.saunaBalance == 0">
              <b>SAUNA</b>
              <br />
              Bal. -
            </h4>
            <h4 v-else>
              <b>SAUNA</b>
              <br />
              Bal. {{ toFormattedToken(boilerRoom.account.saunaBalance) }}
            </h4>
          </div>
          <div class="price-value">
            <span
              class="price-num"
              :class="{
                'price-num__disabled':
                  !$store.state.isLogin || !boilerRoom.account.isApproved,
              }"
              >{{ redeemSaunaAmount }}</span
            >
          </div>
        </div>

        <div class="fee add-flex j-sb" v-if="redeemingFee > 0">
          <p class="sub-title">Redeeming Fee</p>
          <p class="sub-title">{{ redeemingFee }}%</p>
        </div>
        <div
          class="fee add-flex j-sb"
          v-if="boilerRoom.account.claimableRedemptionsBalance.busdBalance > 0"
        >
          <p class="sub-title">Claimable BUSD</p>
          <p class="sub-title">
            {{
              toFormattedToken(
                boilerRoom.account.claimableRedemptionsBalance.busdBalance
              )
            }}
          </p>
        </div>
        <div
          class="fee add-flex j-sb"
          v-if="boilerRoom.account.claimableRedemptionsBalance.saunaBalance > 0"
        >
          <p class="sub-title">Claimable SAUNA</p>
          <p class="sub-title">
            {{
              toFormattedToken(
                boilerRoom.account.claimableRedemptionsBalance.saunaBalance
              )
            }}
          </p>
        </div>
        <div class="connect">
          <input-button
            v-if="!$store.state.isLogin"
            :size="'big'"
            @click="openModal('modal-connect-wallet')"
            >connect to wallet</input-button
          >
          <input-button
            v-if="$store.state.isLogin && !boilerRoom.account.isApproved"
            :size="'large'"
            :is-loading="isLoading"
            :disabled="isLoading"
            @click="approve()"
            >{{ isLoading ? "Approving" : "Approve" }}</input-button
          >
          <input-button
            v-if="
              $store.state.isLogin &&
              boilerRoom.account.isApproved &&
              boilerRoom.account.claimableRedemptionsBalance.busdBalance == 0 &&
              boilerRoom.account.claimableRedemptionsBalance.saunaBalance == 0
            "
            :size="'large'"
            :is-loading="isLoading"
            :disabled="isDisabledRedeeming"
            @click="redeem()"
            >{{ isLoading ? "Redeeming" : "Redeem" }}</input-button
          >
          <input-button
            v-if="
              $store.state.isLogin &&
              boilerRoom.account.isApproved &&
              boilerRoom.account.claimableRedemptionsBalance.busdBalance > 0 &&
              boilerRoom.account.claimableRedemptionsBalance.saunaBalance > 0
            "
            :size="'large'"
            :is-loading="isLoading"
            :disabled="
              boilerRoom.account.claimableRedemptionsBalance.busdBalance == 0 &&
              boilerRoom.account.claimableRedemptionsBalance.saunaBalance == 0
            "
            @click="redeem()"
            >{{ isLoading ? "Claiming" : "Claim" }}</input-button
          >
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import InputButton from "@/components/atoms/InputButton";
import numFormat from "number-format.js";
import { MAX_UINT256 } from "@/utils/constants";
import busdToken from "@/domain/boilerRoom/otherTokens/busdToken";
import { getBoilerRoom, addToMetamask } from "@/utils/boilerRoom";
import token from "@/domain/boilerRoom/token";

export default {
  name: "BoilerIndex",
  props: {
    boilerRoom: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    InputButton,
  },
  data() {
    return {
      isMintBoilerEditing: false,
      isActive: "1",
      mintBusdValue: `${0}`,
      mintBoilerValue: `${0}`,
      busdValue: `${0}`,
      boilerValue: `${0}`,
      isLoading: false,
      checkStatusInterval: null,
      selectedInputElement: null,
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
    web3() {
      return this.$store.state.web3;
    },
    types() {
      return {
        approve: "approve",
        mint: "mint",
        redeem: "redeem",
        claimMint: "claimMint",
        claimRedeem: "claimRedeem",
      };
    },
    mintMin() {
      return `${0}`;
    },
    mintMax() {
      return this.web3.instance.utils.toBN(this.boilerRoom.account.busdBalance);
    },
    mintingFee() {
      return (
        (this.boilerRoom.allFees.mFee /
          this.boilerRoom.allFees.mFeeDenominator) *
        100
      );
    },
    isDisabledMinting() {
      let decimalLength = 0;
      let maxDecimalLength = 5;

      if (this.mintBoilerValue.includes(".")) {
        decimalLength = this.mintBoilerValue.split(".")[1].length;
      }

      if (
        this.mintBoilerValue <= 0 ||
        !this.mintBoilerValue ||
        decimalLength > maxDecimalLength
      ) {
        return true;
      }

      let mintBoilerValueInWei = this.web3.instance.utils.toWei(
        this.mintBoilerValue,
        "ether"
      );

      return (
        this.isLoading ||
        !this.boilerRoom.isMintable ||
        this.web3.instance.utils
          .toBN(mintBoilerValueInWei)
          .gt(this.web3.instance.utils.toBN(this.mintMax)) ||
        this.web3.instance.utils
          .toBN(mintBoilerValueInWei)
          .lte(this.web3.instance.utils.toBN(this.mintMin))
      );
    },
    redeemMin() {
      return `${0}`;
    },
    redeemMax() {
      return this.web3.instance.utils
        .toBN(this.boilerRoom.account.balance)
        .toString();
    },
    redeemingFee() {
      return (
        (this.boilerRoom.allFees.rFee /
          this.boilerRoom.allFees.rFeeDenominator) *
        100
      );
    },
    redeemBusdAmount() {
      let decimalLength = 0;
      let maxDecimalLength = 18;

      if (this.boilerValue.includes(".")) {
        decimalLength = this.boilerValue.split(".")[1].length;
      }

      if (
        this.boilerValue <= 0 ||
        !this.boilerValue ||
        decimalLength > maxDecimalLength
      ) {
        return `${0}`;
      }

      let boilerValueInWei = this.web3.instance.utils.toWei(
        this.boilerValue,
        "ether"
      );

      let amount = this.web3.instance.utils
        .toBN(boilerValueInWei)
        .mul(this.web3.instance.utils.toBN(this.boilerRoom.stakedPeggedToken))
        .div(this.web3.instance.utils.toBN(this.boilerRoom.totalSupply))
        .toString();

      let fee = this.web3.instance.utils
        .toBN(amount)
        .mul(this.web3.instance.utils.toBN(this.boilerRoom.allFees.rFee))
        .div(
          this.web3.instance.utils.toBN(this.boilerRoom.allFees.rFeeDenominator)
        )
        .toString();

      let actualAmount = this.web3.instance.utils
        .toBN(amount)
        .sub(this.web3.instance.utils.toBN(fee))
        .toString();

      return this.toFiveDecimals(actualAmount);
    },
    redeemSaunaAmount() {
      let decimalLength = 0;
      let maxDecimalLength = 18;

      if (this.boilerValue.includes(".")) {
        decimalLength = this.boilerValue.split(".")[1].length;
      }

      if (
        this.boilerValue <= 0 ||
        !this.boilerValue ||
        decimalLength > maxDecimalLength
      ) {
        return `${0}`;
      }

      let boilerValueInWei = this.web3.instance.utils.toWei(
        this.boilerValue,
        "ether"
      );

      let amount = this.web3.instance.utils
        .toBN(boilerValueInWei)
        .mul(
          this.web3.instance.utils.toBN(this.boilerRoom.stakedPeggedTokenOne)
        )
        .div(this.web3.instance.utils.toBN(this.boilerRoom.totalSupply))
        .toString();

      let fee = this.web3.instance.utils
        .toBN(amount)
        .mul(this.web3.instance.utils.toBN(this.boilerRoom.allFees.rFee))
        .div(
          this.web3.instance.utils.toBN(this.boilerRoom.allFees.rFeeDenominator)
        )
        .toString();

      let actualAmount = this.web3.instance.utils
        .toBN(amount)
        .sub(this.web3.instance.utils.toBN(fee))
        .toString();

      return this.toFiveDecimals(actualAmount);
    },
    isDisabledRedeeming() {
      let decimalLength = 0;
      let maxDecimalLength = 5;

      if (this.boilerValue.includes(".")) {
        decimalLength = this.boilerValue.split(".")[1].length;
      }

      if (
        this.boilerValue <= 0 ||
        !this.boilerValue ||
        decimalLength > maxDecimalLength
      ) {
        return true;
      }

      let boilerValueInWei = this.web3.instance.utils.toWei(
        this.boilerValue,
        "ether"
      );

      return (
        this.isLoading ||
        !this.boilerRoom.isRedeemable ||
        this.web3.instance.utils
          .toBN(boilerValueInWei)
          .gt(this.web3.instance.utils.toBN(this.redeemMax)) ||
        this.web3.instance.utils
          .toBN(boilerValueInWei)
          .lte(this.web3.instance.utils.toBN(this.redeemMin))
      );
    },
  },
  methods: {
    toFormattedToken(num) {
      let numString = numFormat(
        "#,##0.000000",
        this.web3.instance.utils.fromWei(num, "ether")
      );

      return numString.slice(0, -1);
    },
    toFiveDecimals(num) {
      let numString = numFormat(
        "##0.000000",
        this.web3.instance.utils.fromWei(num, "ether")
      );

      return numString.slice(0, -1);
    },
    openModal(target) {
      this.$store.dispatch("openModal", target);
    },
    handleKeydown(e) {
      const invalidKeys = ["+", "-", "e", "E"];

      if (invalidKeys.includes(e.key)) {
        e.preventDefault();
      }

      let decimalLength = 0;
      const maxDecimalLength = 5;
      const validKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

      if (this.isActive == "1" && validKeys.includes(e.key)) {
        if (!this.isMintBoilerEditing) {
          if (this.mintBusdValue.includes(".")) {
            decimalLength = this.mintBusdValue.split(".")[1].length + 1;
            if (
              decimalLength > maxDecimalLength &&
              this.selectedInputElement != "mintBusdValueRef"
            ) {
              e.preventDefault();
            }
          }
        }
        if (this.isMintBoilerEditing) {
          if (this.mintBoilerValue.includes(".")) {
            decimalLength = this.mintBoilerValue.split(".")[1].length + 1;
            if (
              decimalLength > maxDecimalLength &&
              this.selectedInputElement != "mintBoilerValueRef"
            ) {
              e.preventDefault();
            }
          }
        }
      }

      if (this.isActive == "2" && validKeys.includes(e.key)) {
        if (this.boilerValue.includes(".")) {
          decimalLength = this.boilerValue.split(".")[1].length + 1;
          if (
            decimalLength > maxDecimalLength &&
            this.selectedInputElement != "redeemBoilerValueRef"
          ) {
            e.preventDefault();
          }
        }
      }

      this.selectedInputElement = null;
    },
    handleSelectedInput(name) {
      this.selectedInputElement = name;
    },
    handleMaxClick() {
      this.isMintBoilerEditing = false;

      this.isActive == "2"
        ? (this.boilerValue = this.toFiveDecimals(
            this.boilerRoom.account.balance
          ))
        : (this.mintBusdValue = this.toFiveDecimals(
            this.boilerRoom.account.busdBalance
          ));
    },
    handlePriceValueClick(name) {
      if (name == "mintBusdValueRef") {
        this.isMintBoilerEditing = false;
      }

      if (name == "mintBoilerValueRef") {
        this.isMintBoilerEditing = true;
      }

      this.selectedInputElement = name;
      this.$refs[name].focus();
    },
    mintBusdAmount(mintAmount) {
      let decimalLength = 0;
      let maxDecimalLength = 18;

      if (mintAmount.includes(".")) {
        decimalLength = mintAmount.split(".")[1].length;
      }

      if (mintAmount <= 0 || !mintAmount || decimalLength > maxDecimalLength) {
        return `${0}`;
      }

      let mintBusdValueInWei = this.web3.instance.utils.toWei(
        mintAmount,
        "ether"
      );

      let amount = this.web3.instance.utils.toBN(mintBusdValueInWei).toString();

      let fee = this.web3.instance.utils
        .toBN(amount)
        .mul(this.web3.instance.utils.toBN(this.boilerRoom.allFees.mFee))
        .div(
          this.web3.instance.utils.toBN(this.boilerRoom.allFees.mFeeDenominator)
        )
        .toString();

      let actualAmount = this.web3.instance.utils
        .toBN(amount)
        .add(this.web3.instance.utils.toBN(fee))
        .toString();

      return this.toFiveDecimals(actualAmount);
    },
    mintBoilerAmount(mintAmount) {
      let decimalLength = 0;
      let maxDecimalLength = 18;

      if (mintAmount.includes(".")) {
        decimalLength = mintAmount.split(".")[1].length;
      }

      if (mintAmount <= 0 || !mintAmount || decimalLength > maxDecimalLength) {
        return `${0}`;
      }

      let mintBoilerValueInWei = this.web3.instance.utils.toWei(
        mintAmount,
        "ether"
      );

      let actualAmount = this.web3.instance.utils
        .toBN(mintBoilerValueInWei)
        .mul(
          this.web3.instance.utils.toBN(this.boilerRoom.allFees.mFeeDenominator)
        )
        .div(
          this.web3.instance.utils
            .toBN(this.boilerRoom.allFees.mFeeDenominator)
            .add(this.web3.instance.utils.toBN(this.boilerRoom.allFees.mFee))
        )
        .toString();

      return this.toFiveDecimals(actualAmount);
    },
    async mint() {
      if (this.boilerRoom.account.claimableMintsBalance > 0) {
        this.isLoading = true;

        let tokenContract = new this.web3.instance.eth.Contract(
          token.abi,
          token.contractAddress
        );

        tokenContract.methods
          .claimMint()
          .send({ from: this.account.address })
          .on("transactionHash", (transactionHash) => {
            this.checkTransactionStatus(
              transactionHash,
              3,
              this.types.claimMint
            );
          })
          .on("error", () => {
            this.incompleteTransaction();
          });
      }

      if (this.boilerRoom.account.claimableMintsBalance == 0) {
        let mintBoilerValueInWei = this.web3.instance.utils.toWei(
          this.mintBoilerValue,
          "ether"
        );

        let isWithinMintingLimitPerTime = this.web3.instance.utils
          .toBN(mintBoilerValueInWei)
          .lte(this.web3.instance.utils.toBN(this.boilerRoom.mintingPerLimit));

        let isWithinMaxSupply = this.web3.instance.utils
          .toBN(this.boilerRoom.totalSupply)
          .add(this.web3.instance.utils.toBN(mintBoilerValueInWei))
          .lte(this.web3.instance.utils.toBN(this.boilerRoom.maxSupply));

        if (!isWithinMintingLimitPerTime) {
          this.$store.dispatch("message/updateMessage", {
            title: "Warning!",
            description: `You cannot mint more than ${numFormat(
              "#,##0.",
              this.web3.instance.utils.fromWei(
                this.boilerRoom.mintingPerLimit,
                "ether"
              )
            )} ${token.name} at a time.`,
          });
          this.$store.dispatch("openModal", "message-modal");
        } else if (!isWithinMaxSupply) {
          this.$store.dispatch("message/updateMessage", {
            title: "Warning!",
            description: `Reached max supply, please try using a smaller amount`,
          });
          this.$store.dispatch("openModal", "message-modal");
        } else {
          this.isLoading = true;

          let tokenContract = new this.web3.instance.eth.Contract(
            token.abi,
            token.contractAddress
          );

          let busdBalanceInEther = this.web3.instance.utils.fromWei(
            this.boilerRoom.account.busdBalance,
            "ether"
          );

          if (busdBalanceInEther - this.mintBusdValue < 0.000009999999999999) {
            let mintBusdAmountInWei = this.web3.instance.utils.fromWei(
              this.boilerRoom.account.busdBalance,
              "ether"
            );

            mintBoilerValueInWei = this.web3.instance.utils
              .toBN(
                this.web3.instance.utils.toWei(mintBusdAmountInWei, "ether")
              )
              .mul(
                this.web3.instance.utils.toBN(
                  this.boilerRoom.allFees.mFeeDenominator
                )
              )
              .div(
                this.web3.instance.utils
                  .toBN(this.boilerRoom.allFees.mFeeDenominator)
                  .add(
                    this.web3.instance.utils.toBN(this.boilerRoom.allFees.mFee)
                  )
              )
              .toString();
          }

          tokenContract.methods
            .mint(mintBoilerValueInWei)
            .send({ from: this.account.address })
            .on("transactionHash", (transactionHash) => {
              this.checkTransactionStatus(transactionHash, 3, this.types.mint);
            })
            .on("error", () => {
              this.incompleteTransaction();
            });
        }
      }
    },
    async redeem() {
      if (
        this.boilerRoom.account.claimableRedemptionsBalance.busdBalance > 0 &&
        this.boilerRoom.account.claimableRedemptionsBalance.saunaBalance > 0
      ) {
        this.isLoading = true;

        let tokenContract = new this.web3.instance.eth.Contract(
          token.abi,
          token.contractAddress
        );

        tokenContract.methods
          .claimRedemption()
          .send({ from: this.account.address })
          .on("transactionHash", (transactionHash) => {
            this.checkTransactionStatus(
              transactionHash,
              3,
              this.types.claimRedeem
            );
          })
          .on("error", () => {
            this.incompleteTransaction();
          });
      }

      if (
        this.boilerRoom.account.claimableRedemptionsBalance.busdBalance == 0 &&
        this.boilerRoom.account.claimableRedemptionsBalance.saunaBalance == 0
      ) {
        this.isLoading = true;

        let tokenContract = new this.web3.instance.eth.Contract(
          token.abi,
          token.contractAddress
        );

        let boilerValueInWei = this.web3.instance.utils.toWei(
          this.boilerValue,
          "ether"
        );

        let balanceInEther = this.web3.instance.utils.fromWei(
          this.boilerRoom.account.balance,
          "ether"
        );

        if (balanceInEther - this.boilerValue < 0.000009999999999999) {
          boilerValueInWei = this.web3.instance.utils
            .toBN(this.boilerRoom.account.balance)
            .toString();
        }

        tokenContract.methods
          .redeem(boilerValueInWei)
          .send({ from: this.account.address })
          .on("transactionHash", (transactionHash) => {
            this.checkTransactionStatus(transactionHash, 3, this.types.redeem);
          })
          .on("error", () => {
            this.incompleteTransaction();
          });
      }
    },
    approve() {
      this.isLoading = true;

      const accountAddress = this.account.address;

      let busdTokenContract = new this.web3.instance.eth.Contract(
        busdToken.abi,
        busdToken.contractAddress
      );

      busdTokenContract.methods
        .approve(token.contractAddress, MAX_UINT256)
        .send({ from: accountAddress })
        .on("transactionHash", (transactionHash) => {
          this.checkTransactionStatus(transactionHash, 3, this.types.approve);
        })
        .on("error", () => {
          this.incompleteTransaction();
        });
    },
    checkTransactionStatus(transactionHash, seconds, type) {
      this.checkStatusInterval = setInterval(() => {
        this.web3.instance.eth
          .getTransactionReceipt(transactionHash)
          .then((result) => {
            if (result) {
              if (result.status) {
                clearInterval(this.checkStatusInterval);
                this.completeTransaction(type);
              }
            }
          });
      }, seconds * 1000);
    },
    completeTransaction(type) {
      getBoilerRoom(this.web3.instance, this.account.address).then((result) => {
        this.$store.dispatch("boilerRoom/update", result);

        this.isLoading = false;

        switch (type) {
          case this.types.approve:
            this.$store.dispatch("toast/updateToast", {
              type: "success",
              title: "Contract Enabled",
              message: `You can now swap to BOILER token.`,
            });
            break;

          case this.types.mint:
            this.$store.dispatch("toast/updateToast", {
              type: "success",
              title: "Success!",
              message: `Your BOILER token(s) have been minted successfully.`,
            });

            this.mintBusdValue = `${0}`;
            this.mintBoilerValue = `${0}`;
            break;

          case this.types.redeem:
            this.$store.dispatch(
              "account/decreaseBalance",
              this.web3.instance.utils.toWei(this.boilerValue, "ether")
            );
            this.$store.dispatch("toast/updateToast", {
              type: "success",
              title: "Success!",
              message: `Your BOILER token(s) have been redeemed successfully.`,
            });

            this.boilerValue = `${0}`;
            break;

          case this.types.claimMint:
            this.$store.dispatch(
              "account/increaseBalance",
              this.boilerRoom.account.claimableMintsBalance
            );
            this.$store.dispatch("toast/updateToast", {
              type: "success",
              title: "Success!",
              message: `Your minted BOILER token(s) have been claimed successfully.`,
            });

            this.mintBusdValue = `${0}`;
            this.mintBoilerValue = `${0}`;
            break;

          case this.types.claimRedeem:
            this.$store.dispatch("toast/updateToast", {
              type: "success",
              title: "Success!",
              message: `Your redeemed BOILER token(s) have been claimed successfully.`,
            });
            this.boilerValue = `${0}`;
            break;

          default:
            this.$store.dispatch("toast/updateToast", {
              type: "success",
              title: "Contract Enabled",
              message: `You can now exchange between BOILER and BUSD tokens.`,
            });
            break;
        }
      });
    },
    incompleteTransaction() {
      this.isLoading = false;

      this.$store.dispatch("toast/updateToast", {
        type: "error",
        title: "Canceled",
        message: "Please try again and confirm the transaction.",
      });
    },
    async addToMetamask() {
      let isAdded = await addToMetamask(this.web3.instance);
      if (isAdded) {
        this.$store.dispatch("toast/updateToast", {
          type: "success",
          title: "Added Token",
          message: "Token has been added to metamask.",
        });
      }
    },
  },
  watch: {
    mintBusdValue(newValue) {
      if (!this.isMintBoilerEditing) {
        this.mintBoilerValue = this.mintBoilerAmount(newValue);
      }
    },
    mintBoilerValue(newValue) {
      if (this.isMintBoilerEditing) {
        this.mintBusdValue = this.mintBusdAmount(newValue);
      }
    },
    "boilerRoom.isMintable": function () {
      this.isActive = !this.boilerRoom.isMintable ? "2" : "1";
    },
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.checkStatusInterval);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
.add-flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  &.j-sb {
    justify-content: space-between;
  }
}
.tab-title {
  margin-bottom: 48px;
}
.boiler-tab {
  font-size: 20px;
  .tabs {
    display: inline-block;
    padding: 8px;
    background: var(--color_bg_parts);
    box-shadow: 0 0 15px #ccc;
    border-radius: 8px;
    width: 270px;
    @include media(sp) {
      width: 100%;
      margin-bottom: 0;
      order: 2;
    }
    label {
      font-size: 18px;
      color: var(--color_font);
      border-radius: 8px;
      padding: 12px 0;
      width: 50%;
      display: inline-block;
      text-align: center;
      cursor: pointer;
    }
    input {
      display: none;
      padding: 16px;
      &:checked + label {
        background: $gradation-vertical;
        color: #fff;
      }
      &:disabled + label {
        cursor: not-allowed;
        color: $gray1;
      }
      &:checked:disabled + label {
        color: #fff;
        background: $color-disabled;
        cursor: not-allowed;
      }
    }
  }
}
.add-token {
  @include media(sp) {
    order: 1;
    margin: 0 auto 32px;
  }
  button {
    color: #fff;
    width: 300px;
    display: block;
    background: $gradation-vertical;
    border-radius: 30px;
    text-align: center;
    line-height: 4.8rem;
    height: 4.8rem;
    position: relative;
    padding-left: 10px;
  }
  img {
    width: 42px;
    height: 42px;
    vertical-align: text-bottom;
    margin-right: 8px;
    position: absolute;
    top: 50%;
    left: 50px;
    transform: translate(0, -50%);
  }
}
.v-wrap {
  border: 1px solid #e4e4e4;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 32px;
}
.price-icon {
  @include media(sp) {
    margin-bottom: 16px;
  }
  figure {
    img {
      width: 50px;
      height: 50px;
      @include media(sp) {
        width: 32px;
        height: 32px;
      }
    }
  }
  h4 {
    font-size: 16px;
    font-weight: 400;
    margin-left: 8px;
    line-height: 1.2;
    @include media(sp) {
      font-size: 14px;
      br {
        display: none;
      }
    }
  }
  b {
    font-size: 25px;
    font-weight: 400;
    @include media(sp) {
      font-size: 22px;
      margin-right: 88px;
    }
  }
}
.tab-contents {
  background: var(--color_bg_parts);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 40px;
  box-shadow: 0 0 15px #ccc;
  .title {
    margin-bottom: 16px;
  }
  .connect {
    button {
      @include media(sp) {
        height: 48px;
      }
    }
  }
}
.price-value {
  background-color: #f7f5fd;
  box-shadow: $box-shadow-inset;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
  padding: 10px 0;
  text-align: right;
  overflow: hidden;

  @include media(sp) {
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }

  &__available {
    font-size: 14px;
    font-weight: 400;
    color: #968faf;
    padding: 0 16px;

    @include media(sp) {
      font-size: 14px;
    }
  }
  &.desc {
    padding: 8px 0 8px;
    position: relative;

    // &::after {
    //   content: "100 BUSD Tokens Avaliable";
    //   font-size: 18px;
    //   font-weight: 400;
    //   color: #968faf;
    //   position: absolute;
    //   top: 8px;
    //   right: 16px;
    //   @include media(sp) {
    //     font-size: 14px;
    //   }
    // }
  }
  input {
    width: 100%;
    text-align: right;
    padding: 0 16px;
    font-size: 28px;
    font-weight: 400;
    color: #968faf;
    @include media(sp) {
      font-size: 18px;
    }
    &:focus {
      outline: 0;
    }
    &:disabled {
      -webkit-text-fill-color: $gray1; /* Override iOS / Android font color change */
      -webkit-opacity: 1; /* Override iOS opacity change affecting text & background color */
      opacity: 1;
      color: $gray1;
      cursor: not-allowed;
    }
  }
  &__inputs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .price-num {
    text-align: right;
    padding: 0 16px;
    font-size: 28px;
    font-weight: 400;
    color: #968faf;

    &__disabled {
      color: $gray1;
    }
    @include media(sp) {
      font-size: 18px;
    }
  }
}
.arrow {
  width: 100%;
  height: 1px;
  background: #e4e4e4;
  margin-bottom: 24px;
  position: relative;
  &::after {
    position: absolute;
    content: "";
    background: url(/assets/sf/icon/b-arrow.svg) no-repeat center center;
    width: 50px;
    height: 50px;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.sub-title {
  font-weight: 400;
  margin-bottom: 16px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.btn-max {
  height: 35px;
  font-size: 1.5rem;
  padding: 0 20px;
  background: $gradation-vertical;
  color: #fff;
  border-radius: 8px;
  margin-left: 16px;
  &:disabled {
    background: $color-disabled;
    cursor: not-allowed;
  }
}
</style>